import * as React from 'react';

import { Container, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalFooter } from 'reactstrap';

import * as AccountsApi from '../../api/accounts';
import * as UtilApi from '../../api/util';

import Localization from '../../config/localization';

import { CITY_HALL } from '../../constants/accountType';

import Notifications from '../../lib/notifications';
import { Capitalize, GetCapitalizeAllWords, GetName, ToNumber, ToString } from '../../lib/utils';

import BackButton from '../../components/BackButton';
import Loader from '../../components/Loader';
import Logo from '../../components/Logo';
import CloseSvg from '../../components/Svg/close';
import PlusSvg from '../../components/Svg/plus';

import { PASSWORD_MIN_LENGTH } from '../../constants/constants';

import './UserAccount.scss';

class UserAccount extends React.Component<UserAccount.IProps, UserAccount.IState> {
  state: UserAccount.IState = {
    loading: true,
    loadingMessage: '',

    formWasSubmitted: false,
    uploadPercent: 0,

    countyName: '',
    localityName: '',

    counties: [],
    custom: [{ label: 'customLabel1', field: 'customField1' }],
    localities: [],
    oldData: this.state,

    accountId: 0,
    accountName: '',
    accountTypeId: 0,
    accountTypeName: '',
    countyCode: '',
    customField1: '',
    customField2: '',
    customField3: '',
    customField4: '',
    customLabel1: Localization.userAccountMajorLabel,
    customLabel2: '',
    customLabel3: '',
    customLabel4: '',
    email: '',
    firstName: '',
    lastName: '',
    localityCode: 0,
    password: '',
    phone: '',
    street: '',
    streetNo: '',
    userName: '',

    logo: undefined,

    changePassword: false,
    confirmPassword: '',
    newPassword: '',
    oldPassword: '',
    passwordChanged: false,

    invalidFileType: false
  };

  async componentDidMount() {
    await this._getMe();

    if (this.state.accountTypeName === CITY_HALL) {
      await this._getCounties();
      await this._getLocalities();
    }

    return undefined;
  }

  renderCountiesSelect = () => {
    return (
      <FormGroup className="w-50">
        <Input
          type="text"
          name="countyCode"
          id="countyCode"
          value={this.state.countyName}
          className="eon-input-text"
          invalid={!this.state.countyCode && this.state.formWasSubmitted}
          disabled
        />
        <FormFeedback tooltip>{Localization.userAccountCountyCodeError}</FormFeedback>
      </FormGroup>
    );
  };

  renderLocalitiesSelect = () => {
    return (
      <FormGroup className="w-50">
        <Input
          type="text"
          name="localityCode"
          id="localityCode"
          value={this.state.localityName}
          onChange={this._setValue}
          className="eon-input-text"
          invalid={!this.state.localityCode && this.state.formWasSubmitted}
          disabled
        />
        <FormFeedback tooltip>{Localization.userAccountLocalityCodeError}</FormFeedback>
      </FormGroup>
    );
  };

  renderCustomField = () => {
    return this.state.custom.map((data, index) => (
      <div key={index} className="w-50">
        <FormGroup className="w-25 d-inline-block">
          <Label for={data.label}>{Localization.userAccountCustomLabel}</Label>
          <Input
            type="text"
            name={data.label}
            id={data.label}
            value={this.state[data.label]}
            onChange={this._setValue}
            disabled={!index}
            className="eon-input-text"
          />
          <FormFeedback tooltip>{Localization.userAccountCustomLabelError}</FormFeedback>
        </FormGroup>
        <FormGroup className="w-75 d-inline-block pl-4 position-relative">
          <Label for={data.field}>{Localization.userAccountCustomFieldLabel}</Label>
          <Input
            type="text"
            name={data.field}
            id={data.field}
            value={this.state[data.field]}
            onChange={this._setValue}
            className={`eon-input-text`}
          />
          <FormFeedback tooltip>{Localization.userAccountCustomFieldError}</FormFeedback>
          {this.state.custom.length === index + 1 ? (
            <div className="position-absolute action-button d-flex">
              {index ? (
                <div id={ToString(index)} onClick={this._removeCustomField} className="c-pointer">
                  <CloseSvg />
                </div>
              ) : null}
              {this.state.custom.length !== 4 ? (
                <div id={ToString(index)} onClick={this._addCustomField} className="d-flex c-pointer">
                  <PlusSvg />
                  <p className="eon-red my-auto text-nowrap align-self-center">{Localization.userAccountAddCustomField}</p>
                </div>
              ) : null}
            </div>
          ) : null}
        </FormGroup>
      </div>
    ));
  };

  renderCityHall = () => {
    if (this.state.accountTypeName !== CITY_HALL) {
      return null;
    }

    return (
      <div>
        <FormGroup className="w-50">
          <Label className="text-nowrap" for="accountName">
            {Localization.userAccountAccountName}
          </Label>
          <Input
            type="text"
            name="accountName"
            id="accountName"
            value={this.state.accountName}
            onChange={this._setValue}
            className={`eon-input-text ${!this.state.accountName && this.state.formWasSubmitted ? 'is-field-error' : ''} `}
            invalid={!this.state.accountName && this.state.formWasSubmitted}
            disabled
          />
          <FormFeedback tooltip>{Localization.userAccountAccountNameError}</FormFeedback>
        </FormGroup>

        {this.state.accountTypeName === CITY_HALL ? (
          <Logo
            defaultMessage={Localization.userAccountUploadImage}
            labelMessage={Localization.userAccountLogo}
            invalidFileType={this.state.invalidFileType}
            errorMessage={Localization.userAccountLogoError}
            logo={this.state.logo}
            onChange={this._fileChange}
            onDelete={this._deleteLogo}
            onMount={this._getLogo}
          />
        ) : null}

        <Label className="w-100 mt-4">
          <h5 className="eon-title  eon-darkgrey mb-0">{Localization.userAccountAddressTitle}</h5>
        </Label>
        {this.renderCountiesSelect()}
        {this.renderLocalitiesSelect()}
        <FormGroup className="w-50">
          <Input
            type="text"
            name="street"
            id="street"
            value={this.state.street}
            onChange={this._setValue}
            onBlur={this._capitalize}
            placeholder={Localization.userAccountStreetLabel}
            className="eon-input-text"
          />
          <FormFeedback tooltip>{Localization.userAccountStreetError}</FormFeedback>
        </FormGroup>
        <FormGroup className="w-50">
          <Input
            type="text"
            name="streetNo"
            id="streetNo"
            value={this.state.streetNo}
            onChange={this._setValue}
            placeholder={Localization.userAccountStreetNoLabel}
            className="eon-input-text"
          />
          <FormFeedback tooltip>{Localization.userAccountStreetNoError}</FormFeedback>
        </FormGroup>
        <Label className="w-100 mt-4">
          <h5 className="eon-title  eon-darkgrey mb-0">{Localization.userAccountSignatoryReportsTitle}</h5>
          <h6 className="eon-title  eon-darkgrey mb-0">{Localization.userAccountSignatoryReportsLabel}</h6>
        </Label>
        <div className="position-relative">{this.renderCustomField()}</div>

        <hr className="mt-5" />
      </div>
    );
  };

  render() {
    return (
      <Container className="user-account px-5 py-4 my-4">
        <BackButton />

        <Loader loading={this.state.loading} loadingMessage={this.state.loadingMessage} />

        <h4 className="mt-5 eon-title eon-red force-wrap">{Localization.userAccountTitle}</h4>
        <h6 className="mt-2 eon-title eon-middle-grey force-wrap">{Localization.userAccountInfo}</h6>
        <Form className="mt-5 position-relative" onSubmit={this._doSubmit}>
          {this.renderCityHall()}

          <FormGroup className="w-50 mt-5">
            <Label for="userName">{Localization.userAccountUserNameLabel}</Label>
            <Input
              type="text"
              name="userName"
              id="userName"
              value={this.state.userName}
              onChange={this._setUserName}
              onBlur={this._capitalize}
              className={`eon-input-text ${!this.state.userName && this.state.formWasSubmitted ? 'is-field-error' : ''} `}
              invalid={!this.state.userName && this.state.formWasSubmitted}
            />
            <FormFeedback tooltip>{Localization.userAccountUserNameError}</FormFeedback>
          </FormGroup>
          <FormGroup className="w-50 mt-4">
            <Label for="email">{Localization.userAccountEmailLabel}</Label>
            <Input
              type="email"
              name="email"
              id="email"
              value={this.state.email}
              onChange={this._setValue}
              className={`eon-input-text ${!this.state.email && this.state.formWasSubmitted ? 'is-field-error' : ''} `}
              invalid={!this.state.email && this.state.formWasSubmitted}
            />
            <FormFeedback tooltip>{Localization.userAccountEmailError}</FormFeedback>
          </FormGroup>
          <div className="position-relative mt-5">
            <button className="eon-button bg-eon-red eon-white d-inline-block mr-5">
              <span className="px-4">{Localization.userAccountSaveButton}</span>
            </button>
            <button type="button" className="eon-button bg-eon-white eon-red d-inline-block mr-5" onClick={this._openChangePassword}>
              <span className="px-4">{Localization.userAccountPasswordChange}</span>
            </button>
          </div>
        </Form>
        <Modal isOpen={this.state.changePassword} centered toggle={this._closeChangePassword}>
          <Form onSubmit={this._saveChangePassword}>
            <ModalBody>
              <Label for="oldPassword" className="mt-3">
                <h6 className="eon-title">{Localization.userAccountOldPasswordLabel}</h6>
              </Label>
              <Input
                type="password"
                name="oldPassword"
                id="oldPassword"
                value={this.state.oldPassword}
                onChange={this._setValue}
                onBlur={this._validateOldPassword}
                onInvalid={this._validateOldPassword}
                className={`eon-input-text ${this.state.oldPasswordClass || ''}`}
                minLength={PASSWORD_MIN_LENGTH}
                required
              />

              <Label for="newPassword" className="mt-3">
                <h6 className="eon-title">{Localization.userAccountNewPasswordLabel}</h6>
              </Label>
              <Input
                type="password"
                name="newPassword"
                id="newPassword"
                value={this.state.newPassword}
                onChange={this._setValue}
                onBlur={this._validateNewPassword}
                onInvalid={this._validateNewPassword}
                className={`eon-input-text ${this.state.newPasswordClass || ''}`}
                minLength={PASSWORD_MIN_LENGTH}
                required
              />

              <Label for="confirmPassword" className="mt-3">
                <h6 className="eon-title">{Localization.userAccountConfirmPasswordLabel}</h6>
              </Label>
              <Input
                type="password"
                name="confirmPassword"
                id="confirmPassword"
                value={this.state.confirmPassword}
                onChange={this._setValue}
                onBlur={this._validateConfirmPassword}
                onInvalid={this._validateConfirmPassword}
                className={`eon-input-text ${this.state.confirmPasswordClass || ''}`}
                pattern={this.state.newPassword}
                invalid={this._invalidPassword()}
                minLength={PASSWORD_MIN_LENGTH}
                required
              />

              <FormFeedback tooltip>{Localization.userAccountPasswordError}</FormFeedback>
            </ModalBody>
            <ModalFooter>
              <button className="eon-button bg-eon-lightgrey eon-middle-grey mr-5" type="button" onClick={this._closeChangePassword}>
                <span className="px-3">{Localization.userAccountPasswordCloseButton}</span>
              </button>
              <button type="submit" className="eon-button bg-eon-red eon-white ml-4" disabled={this._disableChangePassword()}>
                <span className="px-3">{Localization.userAccountPasswordSaveButton}</span>
              </button>
            </ModalFooter>
          </Form>
        </Modal>
      </Container>
    );
  }

  _getMe = async () => {
    try {
      await this.setState({ loading: true });

      const response = await AccountsApi.GetMe();
      const json = response.data;

      const data = {
        accountId: ToNumber(json.accountId),
        accountName: ToString(json.accountName),
        accountTypeId: ToNumber(json.accountTypeId),
        accountTypeName: ToString(json.accountTypeName),
        countyCode: ToString(json.countyCode),
        customField1: ToString(json.customField1),
        customField2: ToString(json.customField2),
        customField3: ToString(json.customField3),
        customField4: ToString(json.customField4),
        customLabel1: ToString(json.customLabel1) || Localization.userAccountMajorLabel,
        customLabel2: ToString(json.customLabel2),
        customLabel3: ToString(json.customLabel3),
        customLabel4: ToString(json.customLabel4),
        email: ToString(json.email),
        localityCode: ToNumber(json.localityCode),
        password: ToString(json.password),
        street: GetCapitalizeAllWords(json.street),
        streetNo: ToString(json.streetNo),

        firstName: GetCapitalizeAllWords(json.firstName),
        lastName: Capitalize(json.lastName),
        phone: ToString(json.phone),

        loading: false
      } as UserAccount.IState;

      if (data.customField2 || data.customLabel2) {
        this._addCustomField();
      }
      if (data.customField3 || data.customLabel3) {
        this._addCustomField();
      }
      if (data.customField4 || data.customLabel4) {
        this._addCustomField();
      }

      if (data.firstName || data.lastName) {
        data.userName = GetName({ firstName: data.firstName, lastName: data.lastName });
      }

      data.oldData = data;

      return this.setState(data);
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false });
    }
  };

  _deleteLogo = async (event: React.MouseEvent<HTMLButtonElement>) => {
    try {
      if (event) {
        event.preventDefault();
      }

      await this.setState({ loading: true });

      await AccountsApi.DeleteLogo();

      await this.setState({ loading: false, logo: undefined, oldData: { ...this.state } });

      return Notifications.success(Localization.userAccountLogoDeletedSuccess);
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false });
    }
  };

  _getLogo = async () => {
    try {
      await this.setState({ loading: true });

      const response = await AccountsApi.GetLogo();

      if (!response.data || !response.data.size) {
        return this.setState({ loading: false, logo: undefined, oldData: { ...this.state } });
      }

      const blob = new File([response.data], '');

      return this.setState({ loading: false, logo: blob, oldData: { ...this.state.oldData, logo: blob } });
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false });
    }
  };

  _getCounties = async () => {
    try {
      await this.setState({ loading: true });

      const response = await UtilApi.GetCounties();

      await this.setState({ counties: response.data });

      if (!this.state.countyCode || !this.state.counties || !this.state.counties.length) {
        return this.setState({ loading: false });
      }

      const currentCounty = this.state.counties.find(county => county.countyCode === this.state.countyCode);

      return this.setState({ countyName: GetCapitalizeAllWords(currentCounty && currentCounty.countyName), loading: false });
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false });
    }
  };

  _getLocalities = async () => {
    try {
      await this.setState({ loading: true });
      const response = await UtilApi.GetLocalities({ countyCode: this.state.countyCode });

      await this.setState({ localities: response.data });

      if (!this.state.localityCode || !this.state.localities || !this.state.localities.length) {
        return this.setState({ loading: false });
      }

      const currentLocality = this.state.localities.find(locality => locality.localityCode === this.state.localityCode);

      return this.setState({ loading: false, localityName: GetCapitalizeAllWords(currentLocality && currentLocality.name) });
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false });
    }
  };

  _validation = (data = this.state) => {
    if (this.state.accountTypeName !== CITY_HALL) {
      if (!data) {
        return false;
      } else if (!data.accountName) {
        return false;
      } else if (!data.email) {
        return false;
      }

      return true;
    }

    if (!data) {
      return false;
    } else if (!data.countyCode) {
      return false;
    } else if (!data.localityCode) {
      return false;
    } else if (!data.email) {
      return false;
    } else if (!data.accountName) {
      return false;
    } else if (!data.accountTypeId) {
      return false;
    }

    return true;
  };

  _doSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    try {
      event.preventDefault();

      await this.setState({ formWasSubmitted: true, loading: true });

      const data = {
        accountName: ToString(this.state.accountName),
        accountTypeId: ToNumber(this.state.accountTypeId),
        accountTypeName: ToString(this.state.accountTypeName),
        countyCode: ToString(this.state.countyCode),
        customField1: ToString(this.state.customField1),
        customField2: ToString(this.state.customField2),
        customField3: ToString(this.state.customField3),
        customField4: ToString(this.state.customField4),
        customLabel1: ToString(this.state.customLabel1),
        customLabel2: ToString(this.state.customLabel2),
        customLabel3: ToString(this.state.customLabel3),
        customLabel4: ToString(this.state.customLabel4),
        email: ToString(this.state.email),
        firstName: GetCapitalizeAllWords(this.state.firstName),
        lastName: Capitalize(this.state.lastName),
        localityCode: ToNumber(this.state.localityCode),
        phone: ToString(this.state.phone),
        street: GetCapitalizeAllWords(this.state.street),
        streetNo: ToString(this.state.streetNo)
      } as UserAccount.IState;

      if (!this._validation(data)) {
        throw new Error(Localization.userAccountInvalidData);
      }

      await AccountsApi.UpdateAccount(this.state.accountId, data);

      await this.setState({ loading: false });

      return this._uploadLogo();
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false });
    }
  };

  _uploadLogo = async () => {
    try {
      if (!this.state.logo || this.state.logo === this.state.oldData.logo) {
        return Notifications.success(Localization.userAccountAccountUpdatedSuccess);
      }

      await this.setState({ loading: true });

      const formData = new FormData();

      formData.append('file', this.state.logo);

      await AccountsApi.UpdateAccountLogo(formData, {
        onUploadProgress: progressEvent => {
          return this.setState({ uploadPercent: Math.round((progressEvent.loaded * 100) / progressEvent.total) });
        }
      });

      Notifications.success(Localization.userAccountAccountUpdatedSuccess);

      return this.setState({ loading: false });
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false });
    }
  };

  _saveChangePassword = async (event: React.FormEvent<HTMLFormElement>) => {
    try {
      event.preventDefault();

      await this.setState({ loading: true });

      const data = { password: this.state.newPassword, oldPassword: this.state.oldPassword } as Account.IPasswordChange;

      await AccountsApi.ChangePassword(data);

      Notifications.success(Localization.userAccountPasswordChangedSuccess);

      return this.setState({ loading: false, oldPassword: '', newPassword: '', confirmPassword: '', changePassword: false });
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false });
    }
  };

  _capitalize = (event: React.FocusEvent<HTMLInputElement>) => {
    event.preventDefault();

    return this.setState({
      firstName: GetCapitalizeAllWords(this.state.firstName),
      lastName: Capitalize(this.state.lastName),
      street: GetCapitalizeAllWords(this.state.street)
    });
  };

  _setValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();

    const element = event.currentTarget || event.target || {};

    return this.setState(prevState => ({ ...prevState, [element.id]: element.value }));
  };

  _setUserName = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();

    const element = event.currentTarget || event.target || {};

    const userName = ToString(element.value).split(' ');

    return this.setState({
      firstName: GetCapitalizeAllWords(userName.shift()),
      lastName: Capitalize(userName.join(' ')),
      userName: Capitalize(element.value)
    });
  };

  _openChangePassword = () => {
    return this.setState({ changePassword: true });
  };

  _closeChangePassword = () => {
    return this.setState({ changePassword: false });
  };

  _validateOldPassword = (event: React.FocusEvent<HTMLInputElement>) => {
    event.preventDefault();

    if (!this.state.oldPassword || this.state.oldPassword.length < 5) {
      return this.setState({ oldPasswordClass: 'is-field-error' });
    }
    return this.setState({ oldPasswordClass: '' });
  };

  _validateNewPassword = (event: React.FocusEvent<HTMLInputElement>) => {
    event.preventDefault();

    if (!this.state.newPassword || this.state.newPassword.length < 5) {
      return this.setState({ newPasswordClass: 'is-field-error' });
    }

    this.setState({ newPasswordClass: '' });

    if (!this.state.confirmPassword) {
      return undefined;
    }

    return this._validateConfirmPassword(event);
  };

  _validateConfirmPassword = (event: React.FocusEvent<HTMLInputElement>) => {
    event.preventDefault();

    if (!this.state.confirmPassword || this.state.confirmPassword !== this.state.newPassword) {
      return this.setState({ confirmPasswordClass: 'is-field-error' });
    }
    return this.setState({ confirmPasswordClass: '' });
  };

  _invalidPassword = () => {
    if (this.state.newPassword && this.state.confirmPassword && this.state.confirmPassword !== this.state.newPassword) {
      return true;
    }
    return false;
  };

  _disableChangePassword = () => {
    if (this.state.oldPasswordClass && this.state.oldPasswordClass.indexOf('is-field-error') !== -1) {
      return true;
    } else if (this.state.newPasswordClass && this.state.newPasswordClass.indexOf('is-field-error') !== -1) {
      return true;
    } else if (this.state.confirmPasswordClass && this.state.confirmPasswordClass.indexOf('is-field-error') !== -1) {
      return true;
    }

    return false;
  };

  _fileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();

    const element = event.currentTarget || event.target || {};

    const data = {
      invalidFileType: false,
      logo: element.files ? element.files[0] : undefined
    } as UserAccount.IState;

    element.value = '';

    if (!new RegExp(element.accept, 'i').test(ToString(data.logo && data.logo.type))) {
      data.invalidFileType = true;
      data.logo = undefined;
    }

    return this.setState(data);
  };

  _addCustomField = (event?: React.MouseEvent<HTMLDivElement>) => {
    if (event) {
      event.preventDefault();
    }

    if (this.state.custom.length > 3) {
      return undefined;
    }

    const data: UserAccount.ICustomLabel = {
      field: `customField${this.state.custom.length + 1}` as UserAccount.ICustomLabel['field'],
      label: `customLabel${this.state.custom.length + 1}` as UserAccount.ICustomLabel['label']
    };

    this.state.custom.push(data);

    return this.forceUpdate();
  };

  _removeCustomField = async (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();

    const custom = this.state.custom.pop() || { label: '', field: '' };

    await this.setState(prevState => ({ ...prevState, [custom.label]: undefined, [custom.field]: undefined }));

    return this.forceUpdate();
  };
}

export default UserAccount;
